import CustomClass from "./custom-class";
import CustomId from "./custom-id";
import Sticky from "./sticky";
import Visibility from "./visibility";
import Position from "./position";
import Filter from "./filter";
import CSSTransformAnimations from "./css-transform-animations";
import EntranceAnimations from "./entrance-animations";
import Transition from "./transition";
import MouseMovement from "./mouse-movement";
import DirectoryConditional from "./directory-conditional";

const coreSupports = [
  DirectoryConditional,
  MouseMovement,
  Filter,
  Position,
  CustomId,
  CustomClass,
  Sticky,
  Visibility,
  CSSTransformAnimations,
  EntranceAnimations,
  Transition,
];

var supportLibrary = coreSupports.reduce(function (obj, x) {
  if (x?.id) {
    obj[[x.id]] = x;
  }
  return obj;
}, {});

function getSupportProps(props) {
  var supportProps = {};

  Object.keys(supportLibrary).map((id) => {
    if (supportLibrary[id].transformProps) {
      supportProps = supportLibrary[id].transformProps(props, supportProps);
    }
  });

  return supportProps;
}

function getDynamicCSS(blockID, props) {
  var dynamicCSS = ``;

  Object.keys(supportLibrary).map((id) => {
    if (supportLibrary[id].dynamicCSS) {
      dynamicCSS += supportLibrary[id].dynamicCSS(blockID, props);
    }
  });

  return dynamicCSS;
}

export { supportLibrary, getSupportProps, getDynamicCSS };
